import React, { useEffect, useState } from 'react';
import './Login.scss';
import langIcon from "../assets/icons/language_icon.png"
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage"
import config, { getHeaders } from '../config';
import { logEventHome } from '../Analytics/AnalyticsEvent';
import { screen } from "../Analytics/EventName"
import { SendGuiDataEvents } from '../CommonSript';
import logo from "../assets/icons/logo.png"

function LoginPage({homeLogo,loading,setLoading}) {
    const [msisdn, setMsisdn] = useState('');
    const [lang, setLang] = useState(localStorage.getItem("lang") ? localStorage.getItem("lang") : "en");
    const history = useHistory()
    const campId = localStorage.getItem("campId")
    const rcId = localStorage.getItem("rcId")

     const openSubscription =()=>{
        history.push('/subs')
     }

    const isFormValid = () => {
        return msisdn.length === 8 ;
    };

    const toggleLanguage = () => {
        const newLang = lang === "en" ? "ar" : "en";
        setLang(newLang);
        localStorage.setItem("appLang", newLang);
        localStorage.setItem("lang", newLang);
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        // Allow only digits to be entered
        if (/^\d*$/.test(value)) {
            setMsisdn(value);
        }
    };

    useEffect(() => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "login";
        guiDataEvents["event"] = "open";
        SendGuiDataEvents(guiDataEvents);
      }, []);

    const callback = () => {
        const msisdn = localStorage.getItem("msisdn")
        const campId = localStorage.getItem("campId")
        const rcId = localStorage.getItem("rcId")
        let guiDataEvents = {
            page: "login",
            event: "callBackApi_request",
            campId:campId,
            rcId:rcId
        };
        SendGuiDataEvents(guiDataEvents);
        const url = "https://camp-report.bngrenew.com/cg_etl_dubai.php"
        const headers={
            ...getHeaders()
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'msisdn': msisdn, 'camp': campId, 'rcid': rcId }),
            headers: headers
        })
            .then(res => {
                console.log("res",res)
                if(res.statusText === "OK"){
                    localStorage.removeItem("campId")
                    localStorage.removeItem("rcId")
                }
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                let guiDataResEvents = {
                    page: "login",
                    event: "callBackApi_response",
                    campId:campId,
                    rcId:rcId
                };
                SendGuiDataEvents(guiDataResEvents);
               if(result === "ok"){
                localStorage.removeItem("campId")
                localStorage.removeItem("rcId")
               }
            },
                (error) => {
                    console.log('error:::', error)
                })
    }

    const checksub = () => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "login";
        guiDataEvents["event"] = "checksub_resquest";
        SendGuiDataEvents(guiDataEvents);
        setLoading(true)
        const url = `${config.get('base')}${config.get('checkSub')}`
        const headers={
            ...getHeaders(),
            // "Language":lang
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 
                'msisdn': msisdn,
                // "pin":urlPin,
             }),
            headers: headers
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                const checksubStatus = result?.subStatus ? result?.subStatus : "failed"
                console.log('result message::', result)
                reactLocalStorage.set("subStatus", result.subStatus)
                reactLocalStorage.set("status_display", result.status_display)
                reactLocalStorage.set("showUnsub",result.showUnsub)
                reactLocalStorage.set("msisdn", result.msisdn)
                
                reactLocalStorage.set("validity",result.validity)
                reactLocalStorage.set("activePlan",result.subType)
                reactLocalStorage.set("msisdn",result.msisdn)
                reactLocalStorage.set("unsubmsg", result.unsubmsg)
                const msisdn = result.msisdn
                setLoading(false)
                let guiDataResEvents = {};
                guiDataResEvents["page"] = "login";
                guiDataResEvents["event"] = "checksub_response";
                guiDataResEvents["status"] = checksubStatus;
                SendGuiDataEvents(guiDataResEvents);
                if(result?.status==="success")
                    {
                        if(result?.subStatus === 'active' && campId && rcId){
                            callback();
                        }
                        if(result?.subStatus==='active')   
                            {
                                sendOtp()
                                localStorage.setItem("wasCheckSubDone",true)
                                // history.push(`/?msisdn=${msisdn}`)
                            }
                            else if(result?.subStatus === 'new'){
                                history.push("/subs");
                            }
                        else{
                            history.push("/subs");
                            }
                    }
                else 
                {
                    history.push({
                        pathname: "/subs",
                        // state: { status: "checksubfailed",customMessage:result?.message }
                        })
                    
                }
                logEventHome(
                    {
                        screen: screen.homePage,
                        event: "checksub_api_success"
                    },
                    {
                        others : {
                            status : result.subStatus  ? result.subStatus  : "",
                            msisdn : msisdn  ? msisdn  : "NA"
                        }
                    });
            },
                (error) => {
                    console.log('error:::', error)
                })
    }

    const sendOtp = () => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "subscription";
        guiDataEvents["event"] = "otp_resquest";
        // guiDataEvents["packType"] = subscriptionRate;
        SendGuiDataEvents(guiDataEvents);
        setLoading(true)
        const url = `${config.get('base')}${config.get('sendOtp')}`
        const headers = {
            ...getHeaders(),
            Language:lang
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'msisdn': msisdn,
                "pinReqtype": 'sms',
            }),
            headers: headers
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                const otpStatus = result?.status
                console.log('result message::', result);
                let guiDataEvents = {};
                guiDataEvents["page"] = "subscription";
                guiDataEvents["event"] = "otp_response";
                guiDataEvents["status"] = otpStatus;
                SendGuiDataEvents(guiDataEvents);

                if (result?.status === "success") {
                    // localStorage.setItem("selector", result?.cta_selector);
                    // localStorage.setItem("tempMsisdn", "971" + msisdn);
                    // localStorage.setItem("packType", subscriptionRate)
                    // setSourceFile(result?.source)
                    setLoading(false);
                    sessionStorage.setItem('page', 'login')
                    history.push({
                        pathname: "/otp",
                        state: { msisdn: msisdn}
                    })
                }
                else if (result?.status === "failure" && result?.content_link) {
                    window.location.replace(result?.content_link)
                }
                else {
                    setLoading(false);
                    console.log("something went wrong")
                    history.push({
                        pathname: "/info",
                        state: { status: "sendOtpfailure" }
                    }
                    )
                }
            },
                (error) => {
                    console.log('error:::', error)
                })
    }

    const hitCheckSub = ()=>{
        checksub()
    }

    return (
        <> {(loading ) ?<div className="loader-container">
        <div className="lds" ></div>
        </div> :
        <div className='logcontainer'>
        <div className="images">
                <img 
                className="logosub"
                src={homeLogo ? homeLogo : logo}></img>
                <img 
                className="lang"
                src={langIcon}
                onClick={toggleLanguage}></img>
            </div>
        <div className="login-container">
            
            <div className="login-box">
                <div className="profile-icon"></div>
                <div className="input-group">
                <span className="input-group-addon mx-1">+965</span>
                <input type="tel" className="form-control" placeholder={lang === "en" ? "Enter your mobile number" : "أدخل رقم هاتفك المحمول"}
                    value={msisdn} onChange={handleInputChange} />
            </div>
            <button className="btn btn-primary subscribe text-white" disabled={!isFormValid()} onClick={hitCheckSub}>{lang === "en" ? "Login" : "تسجيل الدخول"}</button>
                {/* <button className="home-btn">Home</button> */}
                <div className='signup' onClick={openSubscription}>
            {lang === "en" ? "SignUp" : "اشتراك"}
            </div>
            </div>
            
        </div>
        </div>
        }
        </>
    );
}

export default LoginPage;
